var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menuList",on:{"click":_vm.routerTo}},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }